import React from 'react';
import WhirlwindDog from '../assets/whirlwind-dog.gif';
import WhirlwindExample from '../assets/whirlwind-example.gif';
import {Content} from '../components/PrimaryContent/Box/Content';
import {PrimaryContentBox} from '../components/PrimaryContent/Box/PrimaryContentBox';
import {PrimaryContentRow} from '../components/PrimaryContent/PrimaryContentRow';

const style = {
	row: `flex flex-col justify-center items-center gap-y-10`,
	header: `font-whirlwindSecondary text-7xl recommended:8xl text-whirlwindPrimaryLight`,
	innerContainer: `flex flex-col justify-center items-center gap-y-40`,
	outerContainer: `flex justify-center items-center   w-full`,
	text: `flex flex-col basis-5/6 gap-y-5`,
	textContent: `flex flex-row justify-center items-center gap-x-10   w-[60%]`,
	textGif: `basis-1/6   rounded-md   opacity-80`,
	tldrContent: `max-w-[75%]`,
	tldrGif: `w-full rounded-md`,
};

export const About = () => {
	return (
		<PrimaryContentRow>
			<PrimaryContentBox tailwindcss={'basis-full max-w-full'}>
				<Content>
					<div className={style.outerContainer}>
						<div className={style.innerContainer}>
							<div className={style.row}>
								<span className={style.header}>whirlwind 🌪️</span>
								<div className={style.textContent}>
									<div className={style.text}>
										<span>
											A web app built to host a browser game,
											integrated with user accounts (Google signin)
											and &quot;lite social media&quot;
											functionality: see other users, make posts, and
											see game-related news posts.
										</span>
										<span>
											Built with Firebase (hosting, authentication,
											database, and security), React, Typescript,
											Tailwind CSS. Cypress used for e2e testing.
										</span>
										<span>
											This web app is a hobby project per se, but
											long term serves primarily as a platform for
											the game project.
										</span>
										<a
											className="text-blue-500 hover:text-blue-600"
											href="https://steamcommunity.com/id/kind0fmagic/"
											target="_blank"
											rel="noreferrer">
											Add me on Steam 😈
										</a>
									</div>
									<img className={style.textGif} src={WhirlwindDog} />
								</div>
							</div>
							<div className={style.row}>
								<span className={style.header}>tl;dr ⏰</span>
								<div className={style.tldrContent}>
									<img
										className={style.tldrGif}
										src={WhirlwindExample}
									/>
								</div>
							</div>
						</div>
					</div>
				</Content>
			</PrimaryContentBox>
		</PrimaryContentRow>
	);
};
